import bridge from '@vkontakte/vk-bridge';
import { createEffect } from 'effector';
import { api } from 'src/shared/api/api';
import { createFormWithPostCard } from 'src/shared/lib/helpers/createFormWithPostCard/createFormWithPostCard';

export const downloadPostCardOnMobileFx = createEffect<HTMLCanvasElement, null, Error>(
  async canvas => {
    const form = await createFormWithPostCard(canvas);

    try {
      const { data } = await api.postPostCard(form);

      if (!data.image.filename) {
        throw new Error('Произошла ошибка при загрузке файла');
      }

      await bridge.send('VKWebAppShowImages', {
        images: [
          `https://gg2023.karusel-tv.ru/${data.image.filename}`
        ]
      });

      return null;
    } catch (error) {
      throw new Error(String(error));
    }
  }
);
